import {TrafficOrderService} from "../../../../services/traffic_order.service";
import {ITrafficOrdersResponse} from "../../../../store/trafficManagement/types";
import {parseQueryString} from "../../../../helpers/parse_query_string";
import {InfiniteData, useInfiniteQuery} from "@tanstack/react-query";

export const getNextPageParam = (lastPage: ITrafficOrdersResponse) => {
    const nextPageUrl = lastPage.pagination.next_page;
    if (!nextPageUrl) return undefined;

    const nextPage = parseQueryString(nextPageUrl).page;
    return nextPage ? Number(nextPage) : undefined;
};

export type OrderQueryType = "active" | "waiting" | "notActive";

export const QUERY_CONFIG: Record<OrderQueryType, {
    key: string;
    fetcher: (crmId: number, params: Record<string, unknown>) => Promise<ITrafficOrdersResponse>;
}> = {
    active: {key: "keyTrafficOrders", fetcher: TrafficOrderService.getTrafficOrdersByCrmId},
    waiting: {key: "keyTrafficOrders", fetcher: TrafficOrderService.getTrafficOrdersByCrmIdWaiting},
    notActive: {key: "keyTrafficOrders", fetcher: TrafficOrderService.getTrafficOrdersByCrmIdNotActive},
};

export const useOrdersQuery = (crmId: number, type: OrderQueryType, params: Record<string, unknown>, enabled = true) => {
    const {key, fetcher} = QUERY_CONFIG[type];

    const selectFlatOrders = (data: InfiniteData<ITrafficOrdersResponse, number>) => ({
        ...data, trafficOrders: data.pages.flatMap((p) => p.data),
    })

    return useInfiniteQuery({
        queryKey: [key, type, crmId, params],
        queryFn: ({pageParam}) => fetcher(crmId, {...params, page: pageParam}),
        getNextPageParam,
        initialPageParam: 1,
        enabled,
        select: selectFlatOrders,
    });
};
